<style>
.box {
  padding-top: 10px;
  display: inline-block;
  width: 260px;
}
.btn-opcion {
  width: 270px;
  margin: 20px;
  display: block;
}
.detail-btn {
  font-size: 10px;
}
/* .texto-boton {
  text-align: left;
} */
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Configuración de Costos</b-card-header>
      <b-card-body>
        <div class="col-12 text-center">
          <div style="font-weight:bold">Seleccioná tus tasas y plazos</div>
          <div>Configurá cuánto pagar por cada venta y cuándo tener tu dinero acreditado</div>
          <div class="box">
            <button class="btn btn-danger btn-opcion" type="button" @click="verSmartPos()">
              <div class="texto-boton">
                Smart-POS
                <br />
                <div class="detail-btn">Elegí los costos para tus ventas con lector de tarjeta</div>
              </div>
            </button>
            <button class="btn btn-danger btn-opcion" type="button" @click="verCodigoQR()">
              Código QR
              <br />
              <div class="detail-btn">Cobrá con tu QR y configurá cuándo recibir tu dinero</div>
            </button>
            <!-- <button class="btn btn-danger btn-opcion" type="button" @click="verLinkDePago()">
              Link de pago
              <br />
              <div
                class="detail-btn"
              >Seleccioná los costos y plazos para recibir las ventas realizadas a travez del link</div>
            </button> -->
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "SmartPost",
  data() {
    return {};
  },
  methods: {
    verSmartPos() {
      let context = this;
      context.$router.push({ name: "SmartPostConfiguration" });
    },
    verCodigoQR() {
      let context = this;
      context.$router.push({ name: "CodigoQRConfiguration" });
    },
    verLinkDePago() {
      let context = this;
      context.$router.push({ name: "LinkDePagoConfiguration" });
    }
  }
};
</script>